<template>
  <vx-card title="GG Kit">
  <div>
    <div v-if="!ggKit">No GG kit</div>
    <div v-else>
      <vs-table data="_">
        <vs-tr>
          <vs-td>Kit Id:</vs-td>
          <vs-td>{{ ggKit.kitId }}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Status:</vs-td>
          <vs-td>{{ ggKit.status }} - {{ ggKit.statusAt }}</vs-td>
        </vs-tr>
      </vs-table>
      <vs-collapse v-if="ggKit && ggKit.statusLogs" type="border" class="mt-2 mb-6" >
        <vs-collapse-item >
          <div slot="header" >
            Status History
          </div>
          <vs-table data="___" v-if="ggKit.statusLogs.length">
            <vs-tr v-for="(statusLog,index) in ggKit.statusLogs" :key="index">
              <vs-td>{{statusLog.status}}</vs-td>
              <vs-td>{{statusLog.statusAt}}</vs-td>
            </vs-tr>
          </vs-table>
        </vs-collapse-item>
      </vs-collapse>
    </div>
  </div>
  </vx-card>
</template>

<script>

export default {
  props: ["ggKit"],
};
</script>
